var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('menu-slider',{ref:"mobile_menu",attrs:{"width":300,"format":"full","direction":"right","opacity":0.15}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }